var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStethoscopeTwo = function SvgStethoscopeTwo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50082 0.640234H9.40082V0.740234V2.12709V2.22709H9.50082H10.9264V4.73899C10.9264 6.97787 9.10463 8.79958 6.86576 8.79958C4.62689 8.79958 2.80521 6.9779 2.80521 4.73903V2.22709H4.18454H4.28454V2.12709V0.740234V0.640234H4.18454H2.01178C1.57355 0.640234 1.21836 0.995426 1.21836 1.43366V4.73903C1.21836 7.85322 3.75161 10.3865 6.8658 10.3865C9.97999 10.3865 12.5132 7.85322 12.5132 4.73903V1.43366C12.5132 0.995426 12.158 0.640234 11.7198 0.640234H9.50082Z",
    fill: "#707683",
    stroke: "#707683",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4227 10.7634H14.3227V10.8634V14.1457C14.3227 16.0022 12.8121 17.5128 10.9556 17.5128C9.09901 17.5128 7.58841 16.0022 7.58841 14.1457V9.61523V9.51523H7.48841H6.10156H6.00156V9.61523V14.1457C6.00156 16.8773 8.22368 19.0997 10.9556 19.0997C13.6872 19.0997 15.9096 16.8773 15.9096 14.1457V10.8634V10.7634H15.8096H14.4227Z",
    fill: "#707683",
    stroke: "#707683",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7824 8.94462V8.9446C17.7824 7.47454 16.5865 6.27891 15.1167 6.27891C13.6464 6.27891 12.4508 7.47454 12.4508 8.94461C12.4508 10.4144 13.6464 11.6103 15.1165 11.6103C16.5866 11.6103 17.7822 10.4144 17.7824 8.94462ZM15.1165 10.0235C14.5215 10.0235 14.0374 9.53937 14.0374 8.94464C14.0374 8.34992 14.5215 7.86583 15.1165 7.86583C15.7112 7.86583 16.1953 8.3499 16.1953 8.94464C16.1953 9.53939 15.7112 10.0235 15.1165 10.0235Z",
    fill: "#707683",
    stroke: "#707683",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16022 -0.1C3.72199 -0.1 3.3668 0.255191 3.3668 0.693426V2.17275C3.3668 2.61099 3.72199 2.96618 4.16022 2.96618C4.59846 2.96618 4.95365 2.61099 4.95365 2.17275V0.693426C4.95365 0.255191 4.59846 -0.1 4.16022 -0.1Z",
    fill: "#707683",
    stroke: "#707683",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5235 -0.1C9.08527 -0.1 8.73008 0.255192 8.73008 0.693426V2.17275C8.73008 2.61099 9.08527 2.96618 9.5235 2.96618C9.96174 2.96618 10.3169 2.61099 10.3169 2.17275V0.693426C10.3169 0.255192 9.96174 -0.1 9.5235 -0.1Z",
    fill: "#707683",
    stroke: "#707683",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStethoscopeTwo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stethoscope-two.58197ab3.svg";
export { ForwardRef as ReactComponent };